// @flow
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import React, { useState } from "react";

type Props = {};

const Buttons = (props: Props) => {
  const [loading, setLoading] = useState(false);
  return (
    <div>
      <Button variant="primaryButton" color="magenta">
        Text secondary
      </Button>
      <Button variant="secondaryButton" color="magenta">
        ΑΠΟΔΟΧΗ
      </Button>
      <Button variant="bigButton" color="magenta">
        Text error
      </Button>
      <Button variant="text" color={"warning"}>
        Text warning
      </Button>
      <Button variant="text" color={"info"}>
        Text info
      </Button>
      <Button variant="text" disabled>
        Text disabled
      </Button>
      <Button variant="text" size={"small"}>
        Text small
      </Button>
      <Button variant="text" size={"medium"}>
        Text medium
      </Button>
      <Button variant="text" size={"large"}>
        Text large
      </Button>
      <Button variant="text" disableElevation>
        Text Disable elevation
      </Button>
      <Button variant="text" startIcon={<DeleteIcon />}>
        Text Start Icon
      </Button>
      <Button variant="text" endIcon={<SendIcon />}>
        Text End Icon
      </Button>
      <br />
      <br />
      <Button variant="contained" color={"primary"}>
        contained primary
      </Button>
      <Button variant="contained" color={"secondary"}>
        contained secondary
      </Button>
      <Button variant="contained" color={"success"}>
        contained success
      </Button>
      <Button variant="contained" color={"error"}>
        contained error
      </Button>
      <Button variant="contained" color={"warning"}>
        contained warning
      </Button>
      <Button variant="contained" color={"info"}>
        contained info
      </Button>
      <Button variant="contained" disabled>
        contained disabled
      </Button>
      <Button variant="contained" size={"small"}>
        contained small
      </Button>
      <Button variant="contained" size={"medium"}>
        contained medium
      </Button>
      <Button variant="contained" size={"large"}>
        contained large
      </Button>
      <Button variant="contained" disableElevation>
        contained Disable elevation
      </Button>
      <Button variant="contained" startIcon={<DeleteIcon />}>
        contained Start Icon
      </Button>
      <Button variant="contained" endIcon={<SendIcon />}>
        contained End Icon
      </Button>
      <br />
      <br />
      <Button variant="outlined" color={"primary"}>
        outlined primary
      </Button>
      <Button variant="outlined" color={"secondary"}>
        outlined secondary
      </Button>
      <Button variant="outlined" color={"success"}>
        outlined success
      </Button>
      <Button variant="outlined" color={"error"}>
        outlined error
      </Button>
      <Button variant="outlined" color={"warning"}>
        outlined warning
      </Button>
      <Button variant="outlined" color={"info"}>
        outlined info
      </Button>
      <Button variant="outlined" disabled>
        outlined disabled
      </Button>
      <Button variant="outlined" size={"small"}>
        outlined small
      </Button>
      <Button variant="outlined" size={"medium"}>
        outlined medium
      </Button>
      <Button variant="outlined" size={"large"}>
        outlined large
      </Button>
      <Button variant="outlined" disableElevation>
        outlined Disable elevation
      </Button>
      <Button variant="outlined" startIcon={<DeleteIcon />}>
        outlined Start Icon
      </Button>
      <Button variant="outlined" endIcon={<SendIcon />}>
        outlined End Icon
      </Button>
      <br />
      <br />
      <Button variant="dashed" color={"primary"}>
        dashed primary
      </Button>
      <Button variant="dashed" color={"secondary"}>
        dashed secondary
      </Button>
      <Button variant="dashed" color={"success"}>
        dashed success
      </Button>
      <Button variant="dashed" color={"error"}>
        dashed error
      </Button>
      <Button variant="dashed" color={"warning"}>
        dashed warning
      </Button>
      <Button variant="dashed" color={"info"}>
        dashed info
      </Button>
      <Button variant="dashed" disabled>
        dashed disabled
      </Button>
      <Button variant="dashed" size={"small"}>
        dashed small
      </Button>
      <Button variant="dashed" size={"medium"}>
        dashed medium
      </Button>
      <Button variant="dashed" size={"large"}>
        dashed large
      </Button>
      <Button variant="dashed" disableElevation>
        dashed Disable elevation
      </Button>
      <Button variant="dashed" startIcon={<DeleteIcon />}>
        dashed Start Icon
      </Button>
      <Button variant="dashed" endIcon={<SendIcon />}>
        dashed End Icon
      </Button>
      <br />
      <br />
      <Button variant="shadow" color={"primary"}>
        shadow primary
      </Button>
      <Button variant="shadow" color={"secondary"}>
        shadow secondary
      </Button>
      <Button variant="shadow" color={"success"}>
        shadow success
      </Button>
      <Button variant="shadow" color={"error"}>
        shadow error
      </Button>
      <Button variant="shadow" color={"warning"}>
        shadow warning
      </Button>
      <Button variant="shadow" color={"info"}>
        shadow info
      </Button>
      <Button variant="shadow" disabled>
        shadow disabled
      </Button>
      <Button variant="shadow" size={"small"}>
        shadow small
      </Button>
      <Button variant="shadow" size={"medium"}>
        shadow medium
      </Button>
      <Button variant="shadow" size={"large"}>
        shadow large
      </Button>
      <Button variant="shadow" disableElevation>
        shadow Disable elevation
      </Button>
      <Button variant="shadow" startIcon={<DeleteIcon />}>
        shadow Start Icon
      </Button>
      <Button variant="shadow" endIcon={<SendIcon />}>
        shadow End Icon
      </Button>
      <br />
      <br />
      <IconButton aria-label="delete">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" color="primary">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" color="secondary">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" color="success">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" color="error">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" color="warning">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" color="info">
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" disabled>
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" size={"small"}>
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" size={"medium"}>
        <DeleteIcon />
      </IconButton>
      <IconButton aria-label="delete" size={"large"}>
        <DeleteIcon />
      </IconButton>
      <br />
      <br />
      <Box>
        <FormControlLabel
          sx={{
            display: "block",
          }}
          control={
            <Switch
              checked={loading}
              onChange={() => setLoading(!loading)}
              name="loading"
              color="primary"
            />
          }
          label="Loading"
        />
        <br />
        <br />
        <Button loading={loading} variant="text">
          Submit
        </Button>
        <Button loading={loading} variant="text" color={"primary"}>
          Submit
        </Button>
        <Button loading={loading} variant="text" color={"secondary"}>
          Submit
        </Button>
        <Button loading={loading} variant="text" color={"success"}>
          Submit
        </Button>
        <Button loading={loading} variant="text" color={"error"}>
          Submit
        </Button>
        <Button loading={loading} variant="text" color={"warning"}>
          Submit
        </Button>
        <Button loading={loading} variant="text" color={"info"}>
          Submit
        </Button>
        <br />
        <br />
        <Button loading={loading} variant="outlined">
          Submit
        </Button>
        <Button loading={loading} variant="outlined" color={"primary"}>
          Submit
        </Button>
        <Button loading={loading} variant="outlined" color={"secondary"}>
          Submit
        </Button>
        <Button loading={loading} variant="outlined" color={"success"}>
          Submit
        </Button>
        <Button loading={loading} variant="outlined" color={"error"}>
          Submit
        </Button>
        <Button loading={loading} variant="outlined" color={"warning"}>
          Submit
        </Button>
        <Button loading={loading} variant="outlined" color={"info"}>
          Submit
        </Button>
        <br />
        <br />
        <Button loading={loading} variant="contained">
          Submit
        </Button>
        <Button loading={loading} variant="contained" color={"primary"}>
          Submit
        </Button>
        <Button loading={loading} variant="contained" color={"secondary"}>
          Submit
        </Button>
        <Button loading={loading} variant="contained" color={"success"}>
          Submit
        </Button>
        <Button loading={loading} variant="contained" color={"error"}>
          Submit
        </Button>
        <Button loading={loading} variant="contained" color={"warning"}>
          Submit
        </Button>
        <Button loading={loading} variant="contained" color={"info"}>
          Submit
        </Button>
        <Button loading={loading} variant="contained">
          Submit
        </Button>
        <br />
        <br />
        <Button loading={loading} variant="dashed">
          Submit
        </Button>
        <Button loading={loading} variant="dashed" color={"primary"}>
          Submit
        </Button>
        <Button loading={loading} variant="dashed" color={"secondary"}>
          Submit
        </Button>
        <Button loading={loading} variant="dashed" color={"success"}>
          Submit
        </Button>
        <Button loading={loading} variant="dashed" color={"error"}>
          Submit
        </Button>
        <Button loading={loading} variant="dashed" color={"warning"}>
          Submit
        </Button>
        <Button loading={loading} variant="dashed" color={"info"}>
          Submit
        </Button>
        <br />
        <br />
        <Button loading={loading} variant="shadow">
          Submit
        </Button>
        <Button loading={loading} variant="shadow" color={"primary"}>
          Submit
        </Button>
        <Button loading={loading} variant="shadow" color={"secondary"}>
          Submit
        </Button>
        <Button loading={loading} variant="shadow" color={"success"}>
          Submit
        </Button>
        <Button loading={loading} variant="shadow" color={"error"}>
          Submit
        </Button>
        <Button loading={loading} variant="shadow" color={"warning"}>
          Submit
        </Button>
        <Button loading={loading} variant="shadow" color={"info"}>
          Submit
        </Button>
        <br />
        <br />
        <Button
          loading={loading}
          loadingIndicator="Loading…"
          variant="outlined"
        >
          Fetch data
        </Button>
        <Button loading loadingPosition="start" startIcon={<SaveIcon />}>
          Save
        </Button>
        <Button loading loadingPosition="end" startIcon={<SaveIcon />}>
          Save
        </Button>
        <Button loading={loading} variant="outlined">
          <span>Submit</span>
        </Button>
      </Box>
      <br />
      <br />
      <Fab color="primary" aria-label="add">
        <AddIcon />
      </Fab>
      <Fab color="secondary" aria-label="edit">
        <EditIcon />
      </Fab>
      <Fab variant="extended">
        <EditIcon sx={{ mr: 1 }} />
        Navigate
      </Fab>
      <Fab disabled aria-label="like">
        <EditIcon />
      </Fab>
      <Fab size="small" color="secondary" aria-label="add">
        <AddIcon />
      </Fab>
      <Fab size="medium" color="secondary" aria-label="add">
        <AddIcon />
      </Fab>
      <Fab color="secondary" aria-label="add">
        <AddIcon />
      </Fab>
      <Fab variant="extended" size="small" color="primary">
        <EditIcon sx={{ mr: 1 }} />
        Extended
      </Fab>
      <Fab variant="extended" size="medium" color="primary">
        <EditIcon sx={{ mr: 1 }} />
        Extended
      </Fab>
      <Fab variant="extended" color="primary">
        <EditIcon sx={{ mr: 1 }} />
        Extended
      </Fab>
    </div>
  );
};

export default Buttons;
